<template>
    <c-badge
        :class="{ 'badge-circle': type === 'circle' }"
        :color="color"
        :text-color="textColor"
        class="h-5 shrink-0 grow-0 !rounded-md px-2 py-0 !text-xs !leading-5 !font-medium"
    >
        <slot />
    </c-badge>
</template>
<script setup>
import { CBadge } from '@coreui/vue/dist/esm/components/badge/index.js';
import { computed } from 'vue';

const props = defineProps(['color', 'type']);

const textColor = computed(() => {
    return props.color === 'danger' ? 'light' : 'body-emphasis';
});
</script>
